<template>
  <section>
    <el-form :inline="true" class="toolbar" :model="searchForm">
      <el-form-item label="支付类型">
        <el-select clearable size="mini" v-model="searchForm.payType" style="width: 100px;"
          @change="payTypeSelectChange">
          <el-option v-for="item in payTypeList" :key="item.type" :label="item.name" :value="item.type" />
        </el-select>
      </el-form-item>
      <el-form-item label="渠道标签">
        <el-select clearable size="mini" v-model="searchForm.channelLabel">
          <el-option v-for="item in channelLabelList" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchForm.status" size="mini" style="width: 120px;" clearable>
          <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="支付时间">
        <el-date-picker v-model="searchForm.searchDate" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="mini" clearable />
      </el-form-item>
      <el-form-item>
        <el-button @click="search" type="primary" size="mini">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="downloadDataList" type="primary" size="mini">下载对账单</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border height="650" style="width: 100%" v-loading="loading">
      <el-table-column align="center" prop="payDate" label="日期" width="100"></el-table-column>
      <el-table-column align="center" prop="payType" label="类型" width="60"></el-table-column>
      <el-table-column align="center" prop="channelLabel" label="渠道标签" width="120"></el-table-column>
      <el-table-column align="center" prop="status" label="状态" width="60"></el-table-column>
      <el-table-column header-align="center" align="right" prop="amount" label="金额" width="120"></el-table-column>
      <el-table-column header-align="center" align="right" prop="cnt" label="订单数" width="80"></el-table-column>
      <el-table-column header-align="center" align="right" prop="cost" label="用时"></el-table-column>
    </el-table>
  </section>
</template>

<script>
import { downloadChannelDataApi, getChannelDataApi, getChannelLabelListApi, } from "../../api/report/index";
import Enum from "../../utils/Enum/Enum";

export default {
  mixins: [],
  data() {
    return {
      loading: false,
      tableData: [],
      searchForm: {
        payType: 1,
        searchDate: this.getCurrentDate()
      },
      channelLabelList: [],
      statusList: Enum.orderStatus,
      payTypeList: [
        { type: 1, name: "代收" },
        { type: 0, name: "代付" }
      ],
    };
  },
  mounted() { },
  methods: {
    search() {
      this.searchForm.isDownload = false;
      this.getList();
    },
    async downloadDataList() {
      this.searchForm.isDownload = true;
      // 校验1：选择支付类型
      if (this.searchForm.payType == null || this.searchForm.payType == '' || !this.searchForm.payType) {
        this.$message.error("请选择支付类型");
        return;
      }
      // 校验2：更严格的判断
      if (!Array.isArray(this.searchForm.searchDate) ||
        this.searchForm.searchDate.length !== 2 ||
        !this.searchForm.searchDate[0] ||
        !this.searchForm.searchDate[1]) {
        this.$message.error("请选择支付时间");
        return;
      }

      // 校验3：计算日期差
      if (this.searchForm.searchDate && this.searchForm.searchDate.length === 2) {
        const startDate = new Date(this.searchForm.searchDate[0]);
        const endDate = new Date(this.searchForm.searchDate[1]);

        // 计算天数差
        const timeDiff = endDate.getTime() - startDate.getTime();
        const dayDiff = timeDiff / (1000 * 3600 * 24);

        if (dayDiff > 4) {
          this.$message.error("下载时间段，请不要超过3天！");
          return;
        }
      }
      let _data = {};
      let content = Object.assign({}, this.searchForm);
      _data.content = content;
      let res = await downloadChannelDataApi(_data);
      const mimeType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const blob = new Blob([res], { type: mimeType });

      const downloadURL = (window.URL || window.webkitURL).createObjectURL(
        blob
      );

      let a = document.createElement("a");
      a.download = "渠道对账单.xlsx";
      // 创建二进制对象
      a.href = downloadURL;
      // 模拟点击
      a.click();
      //释放资源并删除创建的a标签
      URL.revokeObjectURL(downloadURL); // a.href
    },
    payTypeSelectChange(value) {
      this.getChannelLabelList(value);
    },
    async getList() {
      this.loading = true;
      let _data = {};
      let content = Object.assign({}, this.searchForm);
      _data.content = content;
      let res = await getChannelDataApi(_data);
      if (res.code == "0000") {
        this.loading = false;
        this.tableData = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    async getChannelLabelList(value) {
      let _data = {};
      let content = Object.assign(
        {},
        {
          payType: value,
        }
      );
      _data.content = content;
      let res = await getChannelLabelListApi(_data);
      if (res.code == "0000") {
        this.channelLabelList = res.data;
      }
    },
    // 获取当前日期（yyyy-MM-dd）
    getCurrentDate() {
      const today = new Date();
      const todayStr = today.toISOString().split('T')[0]; // 格式: yyyy-MM-dd
      return [todayStr, todayStr]; // 开始和结束都是当天
    }
  },
  components: {},
};
</script>

<style lang="scss" scoped>
:deep(.table_header) {
  color: blue;

  cursor: pointer;
}

:deep(.table_header .cell) {
  text-decoration: underline;
}
</style>
